import React, { type JSX } from 'react'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  label?: string
  className?: string
  children?: string | JSX.Element
}

const Label = ({ id, label, className, children }: LabelProps) => (
  <label htmlFor={id} className={className}>
    {children || label}
  </label>
)

export default Label
